import { Grid, makeStyles } from "@material-ui/core";
import { DefaultInfo } from "components/NothingRight";
import useText from "constants/text";
import { NewRequestQuoteContext } from "contexts/RequestQuoteContext";
import React from "react";
import { CollipsableStopsTour } from "../Tour/refontTourRequest/Collapse";
import { RightSideSamaPapserContainer } from "./MainStyles";
import SchedulingDetails from "./RightSideComponents/components/SchedulingDetails";

export const requestContainerBgColor = {
  MAD: "252, 254, 255",
  NT: "194,202,236",
  TR: "202, 234, 195",
};

export const useStyles = makeStyles(() => ({
  hr: {
    width: "89%",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
    height: "2px",
    border: "none",
  },
  hr2: {
    width: "76%",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
    height: "2px",
    border: "none",
  },
  hr3: {
    width: "62%",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
    height: "2px",
    border: "none",
  },
  hr4: {
    width: "90%",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
    height: "2px",
    border: "none",
  },
  hr5: {
    width: "88%",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
    height: "2px",
    border: "none",
  },
  hr6: {
    width: "68%",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
    height: "2px",
    border: "none",
  },
  p: {
    color: "#757a93",
    fontSize: "14px",
    marginLeft: "5px",
    width: "98%",
    wordWrap: "break-word",
  },
  gridStyle: {
    display: "flex",
    alignItems: "center",
    color: "#399ebf",
    fontSize: 12,
    fontWeight: "bold",
  },
  details: {
    display: "flex",
    flex: "auto",
    color: "#399ebf",
    fontSize: "14px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    paddingTop: "1%",
    paddingLeft: "1%"

  },
}));

export default function TourSideDetails() {
  const { requestQuoteTour, step } = React.useContext(NewRequestQuoteContext);
  const { text } = useText();
  const styles = useStyles();

  return (
    <RightSideSamaPapserContainer>
      {requestQuoteTour?.templateAxes?.length && requestQuoteTour?.templateAxes[0].name !== "" && step !== 2 ? (
        <>
          <Grid container spacing={1}>
            <Grid item xs={12} className={styles.gridStyle}>
              Stops
              <hr className={styles.hr} />
            </Grid>
            <Grid item xs={12}>
              <CollipsableStopsTour requestQuoteTour={requestQuoteTour} />
            </Grid>
            {requestQuoteTour?.productType?.length && (
              <Grid item xs={12}>
                <SchedulingDetails requestToDisplay={requestQuoteTour} isDisabled />
              </Grid>
            )}
            {requestQuoteTour?.additionnalInfos && (
              <>
                <Grid item xs={12} className={styles.gridStyle}>
                  {text.all.additional_infos}
                  <hr className={styles.hr3} />
                </Grid>
                <Grid item xs>
                  <p className={styles.p}>{requestQuoteTour?.additionnalInfos}</p>
                </Grid>
              </>
            )}
          </Grid>
        </>
      ) : (
        <DefaultInfo />
      )}
    </RightSideSamaPapserContainer>
  );
}
